export const NewHouseSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={200} height={200} fill="none">
    <path
      fill="#0038FF"
      d="M180.913 47.505a68.666 68.666 0 0 0-2.075-3.249c-9.598-14.104-25.578-23.76-41.109-28.133-6.803-1.919-13.789-2.922-20.762-3.179-45.737-1.662-62.54 36.05-77.276 45.773-14.736 9.724-37.35 26.332-34.512 61.22 2.153 26.526 17.244 51.89 44.804 63.432a78.397 78.397 0 0 0 9.565 3.301c6.212 1.709 12.945 2.782 20.2 3.104 20.836.929 37.755-4.094 54.305-16.742 3.847-2.94 7.673-6.257 12.665-6.62 3.629-.264 7.07 1.04 3.276 4.546-4.458 4.122.686 12.229 12.003 6.597 18.9-9.407 26.675-29.703 30.338-50.34 4.496-25.332 2.317-56.834-11.422-79.71Z"
    />
    <path
      fill="#fff"
      d="M180.913 47.505a68.666 68.666 0 0 0-2.075-3.249c-9.598-14.104-25.578-23.76-41.109-28.133-6.803-1.919-13.789-2.922-20.762-3.179-45.737-1.662-62.54 36.05-77.276 45.773-14.736 9.724-37.35 26.332-34.512 61.22 2.153 26.526 17.244 51.89 44.804 63.432a78.397 78.397 0 0 0 9.565 3.301c6.212 1.709 12.945 2.782 20.2 3.104 20.836.929 37.755-4.094 54.305-16.742 3.847-2.94 7.673-6.257 12.665-6.62 3.629-.264 7.07 1.04 3.276 4.546-4.458 4.122.686 12.229 12.003 6.597 18.9-9.407 26.675-29.703 30.338-50.34 4.496-25.332 2.317-56.834-11.422-79.71Z"
      opacity={0.7}
    />
    <path
      stroke="#363946"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      d="M173.106 54.654s-2.099-8.746-14.344-10.496c-12.246-1.75-13.995 8.747-16.444 10.146-2.45 1.4-3.849-2.449-7.698-2.099-3.848.35-5.948 3.499-7.697 4.899-1.749 1.4-4.898-2.8-7.347-2.1-2.449.7-4.548 4.199-4.548 4.199h71.024s-2.449-3.849-5.948-5.248c-3.499-1.4-4.898.7-6.998.7ZM55.194 80.92s-1.504-6.27-10.282-7.524c-8.778-1.254-10.032 6.27-11.787 7.273-1.756 1.003-2.759-1.755-5.517-1.505-2.76.251-4.264 2.508-5.518 3.512-1.254 1.003-3.511-2.007-5.267-1.505-1.755.501-3.26 3.01-3.26 3.01h50.91s-1.755-2.76-4.263-3.763c-2.508-1.003-3.51.502-5.016.502ZM78.086 27.94s-.954-3.974-6.516-4.768c-5.561-.794-6.356 3.973-7.468 4.608-1.113.636-1.748-1.112-3.496-.953-1.748.159-2.702 1.589-3.496 2.225-.795.635-2.225-1.272-3.338-.954-1.112.318-2.066 1.907-2.066 1.907h32.26s-1.113-1.748-2.702-2.384c-1.59-.635-2.225.318-3.178.318ZM123.778 36.13a9.194 9.194 0 0 0 9.194-9.194 9.194 9.194 0 1 0-9.194 9.194ZM123.778 11.508v3.74M123.778 39.246v3.74M134.908 16.118l-2.645 2.645M115.294 35.732l-2.644 2.644M139.517 27.247h-3.74M111.78 27.247h-3.74M134.908 38.376l-2.645-2.644M115.294 18.763l-2.644-2.645"
    />
    <path
      fill="#0038FF"
      stroke="#363946"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      d="M145.947 78.088s1.847-.462 2.4-.277c.554.185-.367.84-.367.84s.46.268.737.914c.277.646-.92.368-.92.368s.366.463-.003.832c-.37.37-2.032-1.477-2.032-1.477s-1.2.739-2.308.647c-1.108-.093-1.754-.37-2.493-1.478-.738-1.108-1.293-1.662-1.293-1.662l-.738-.276 1.108-.647s.923-.83 1.846-.739c.923.093 1.293.37 1.293.37s.554-1.478 1.385-2.032c.83-.554 3.416-1.293 4.247-1.754.831-.462.646.277.369.739-.277.461-1.108.83-1.477 1.015-.369.185 1.939.278 1.569.74-.369.46-1.754.645-1.754.645s1.293.462 1.016.831c-.278.37-1.385.37-1.385.37s.369.923-.185.923h-.554s.278 1.293-.461 1.108Z"
    />
    <path
      fill="#363946"
      stroke="#363946"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      d="M143.177 75.503s-.739-1.477-.369-2.4c.369-.924 3.785-3.325 3.693-2.401-.093.923-1.016 1.477-1.016 1.477s1.385-.461 1.385-.092v.369s-1.57.37-2.308 1.016c-.739.646-1.385 2.03-1.385 2.03Z"
    />
    <path
      fill="#363946"
      d="M141.016 76.497a.275.275 0 1 0-.001-.55.275.275 0 0 0 .001.55Z"
    />
    <path
      fill="#fff"
      stroke="#363946"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={0.5}
      d="M144.724 79.044c-.166.56-1.046.792-1.966.52-.92-.273-1.531-.948-1.364-1.508.166-.56 1.046-.793 1.966-.52.92.273 1.53.948 1.364 1.508Z"
    />
    <path
      fill="#0038FF"
      stroke="#363946"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      d="M54.109 54.423s-1.847-.461-2.401-.277c-.554.185.368.84.368.84s-.46.268-.737.914c-.277.647.92.368.92.368s-.366.463.003.832c.37.37 2.031-1.477 2.031-1.477s1.2.74 2.309.647c1.108-.093 1.754-.37 2.492-1.478.739-1.108 1.293-1.662 1.293-1.662l.739-.277-1.108-.646s-.923-.83-1.847-.739c-.923.092-1.293.37-1.293.37s-.554-1.478-1.384-2.032c-.831-.554-3.417-1.293-4.248-1.754-.83-.462-.646.276-.369.739.277.461 1.108.83 1.477 1.015.37.185-1.938.277-1.57.739.37.462 1.755.646 1.755.646s-1.293.462-1.015.831c.277.37 1.384.37 1.384.37s-.369.922.185.922h.554s-.277 1.294.462 1.11Z"
    />
    <path
      fill="#363946"
      stroke="#363946"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      d="M56.879 51.838s.739-1.477.369-2.4c-.37-.924-3.786-3.324-3.693-2.4.092.922 1.015 1.476 1.015 1.476s-1.384-.461-1.384-.092v.37s1.57.368 2.308 1.015c.738.646 1.385 2.031 1.385 2.031Z"
    />
    <path
      fill="#363946"
      d="M58.765 52.557a.275.275 0 1 0 .55 0 .275.275 0 0 0-.55 0Z"
    />
    <path
      fill="#fff"
      stroke="#363946"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={0.5}
      d="M55.331 55.38c.166.56 1.047.792 1.967.519.92-.273 1.53-.948 1.364-1.508-.166-.56-1.046-.793-1.966-.52-.92.273-1.53.948-1.365 1.508Z"
    />
    <path
      fill="#0038FF"
      stroke="#363946"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      d="M49.15 123.187s-3.65-5.805-10.266-9.237c-6.617-3.43-9.438-6.818-6.004-6.616 4.166.245 13.6 3.553 17.889 15.193 1.85 5.023-1.618.66-1.618.66Z"
    />
    <path
      stroke="#363946"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      d="M48.93 121.67s-3.308-6.617-9.556-9.802"
    />
    <path
      fill="#0038FF"
      stroke="#363946"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      d="M53.13 127.201s-2.087-5.837-.83-12.455c1.257-6.618.425-10.515-1.349-7.962-2.152 3.098-5.07 11.65.807 21.198 2.535 4.12 1.372-.781 1.372-.781Z"
    />
    <path
      stroke="#363946"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      d="M52.174 126.198s-2.854-6.047-1.628-12.267"
    />
    <path
      fill="#0038FF"
      stroke="#363946"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      d="M49.421 120.268s-2.087-5.837-.83-12.455c1.258-6.618.426-10.515-1.348-7.962-2.153 3.097-5.071 11.65.806 21.198 2.536 4.12 1.372-.781 1.372-.781Z"
    />
    <path
      stroke="#363946"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      d="M48.93 121.67s-3.318-8.452-2.092-14.672"
    />
    <path
      fill="#0038FF"
      stroke="#363946"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      d="M132.478 115.956s3.651-5.805 10.268-9.236c6.616-3.431 9.437-6.819 6.003-6.617-4.166.245-13.6 3.553-17.889 15.193-1.85 5.023 1.618.66 1.618.66Z"
    />
    <path
      stroke="#363946"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      d="M132.698 114.439s3.309-6.617 9.558-9.802"
    />
    <path
      fill="#0038FF"
      stroke="#363946"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      d="M128.5 119.97s2.086-5.837.829-12.455-.425-10.515 1.349-7.962c2.152 3.097 5.071 11.65-.806 21.199-2.536 4.12-1.372-.782-1.372-.782Z"
    />
    <path
      stroke="#363946"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      d="M129.455 118.967s2.854-6.047 1.628-12.267"
    />
    <path
      fill="#0038FF"
      stroke="#363946"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      d="M132.208 113.037s2.087-5.837.83-12.455c-1.258-6.618-.426-10.515 1.348-7.962 2.153 3.098 5.071 11.65-.806 21.198-2.536 4.12-1.372-.781-1.372-.781Z"
    />
    <path
      stroke="#363946"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      d="M132.698 114.439s3.32-8.452 2.094-14.672"
    />
    <path
      fill="#363946"
      stroke="#363946"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      d="M134.144 95.258H96.121L74.848 61.43h38.024l21.272 33.828Z"
    />
    <path
      fill="#C7C7C7"
      stroke="#363946"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      d="M90.83 94.095H51.858v34.425H90.83V94.095Z"
    />
    <path
      fill="#fff"
      stroke="#363946"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      d="M129.802 128.52H90.83V94.095l19.81-31.502 19.162 31.502v34.425Z"
    />
    <path
      fill="#C7C7C7"
      stroke="#363946"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      d="M99.274 100.266h-3.898v11.691h3.898v-11.691Z"
    />
    <path
      fill="#363946"
      stroke="#363946"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      d="M103.171 100.266h-3.897v11.691h3.897v-11.691Z"
    />
    <path
      fill="#C7C7C7"
      stroke="#363946"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      d="M107.068 100.266h-3.897v11.691h3.897v-11.691Z"
    />
    <path
      fill="#919191"
      stroke="#363946"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      d="M81.412 100.266h-3.248v11.691h3.248v-11.691Z"
    />
    <path
      fill="#363946"
      stroke="#363946"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      d="M84.66 100.266h-3.248v11.691h3.247v-11.691Z"
    />
    <path
      fill="#919191"
      stroke="#363946"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      d="M87.907 100.266h-3.248v11.691h3.248v-11.691ZM57.379 100.266H54.13v11.691h3.248v-11.691Z"
    />
    <path
      fill="#363946"
      stroke="#363946"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      d="M60.626 100.266H57.38v11.691h3.247v-11.691Z"
    />
    <path
      fill="#919191"
      stroke="#363946"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      d="M63.874 100.266h-3.248v11.691h3.248v-11.691Z"
    />
    <path
      fill="#C7C7C7"
      stroke="#363946"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      d="M119.084 100.266h-3.897v11.691h3.897v-11.691Z"
    />
    <path
      fill="#363946"
      stroke="#363946"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      d="M122.982 100.266h-3.898v11.691h3.898v-11.691Z"
    />
    <path
      fill="#C7C7C7"
      stroke="#363946"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      d="M126.879 100.266h-3.897v11.691h3.897v-11.691ZM109.991 81.104h-2.598v7.145h2.598v-7.145Z"
    />
    <path
      fill="#363946"
      stroke="#363946"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      d="M112.589 81.104h-2.598v7.145h2.598v-7.145Z"
    />
    <path
      fill="#C7C7C7"
      stroke="#363946"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      d="M115.187 81.104h-2.598v7.145h2.598v-7.145Z"
    />
    <path
      fill="#0038FF"
      stroke="#363946"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      d="M49.689 95.258h41.848L112.81 61.43H70.962L49.689 95.258Z"
    />
    <path
      fill="#C7C7C7"
      stroke="#363946"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      d="M82.362 76.71H65.838v10.936h16.525V76.71Z"
    />
    <path
      fill="#fff"
      stroke="#363946"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      d="m82.362 76.71 11.42-7.843-11.42 18.779V76.71Z"
    />
    <path
      fill="#0038FF"
      stroke="#363946"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      d="M64.513 77.082H81.82l11.961-8.215H76.476l-11.963 8.215Z"
    />
    <path
      fill="#919191"
      stroke="#363946"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      d="M72.48 79.032h-2.597v7.145h2.598v-7.145Z"
    />
    <path
      fill="#363946"
      stroke="#363946"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      d="M75.079 79.032H72.48v7.145h2.598v-7.145Z"
    />
    <path
      fill="#919191"
      stroke="#363946"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      d="M77.677 79.032H75.08v7.145h2.598v-7.145Z"
    />
    <path
      fill="#fff"
      stroke="#363946"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      d="M102.734 56.3h-1.453v10.614l1.453-2.347V56.3Z"
    />
    <path
      fill="#C7C7C7"
      stroke="#363946"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      d="M101.348 56.3h-4.295v10.614h4.295V56.3Z"
    />
    <path
      fill="#363946"
      stroke="#363946"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      d="M76.345 102.231H66.342v26.289h10.003v-26.289Z"
    />
    <path
      fill="#fff"
      stroke="#363946"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      d="M75.817 115.342a.885.885 0 1 0-1.77 0 .885.885 0 0 0 1.77 0ZM49.795 123.021s-8.377-4.584-16.2-5.435c-7.823-.852-12.349 2.793-12.31 4.376.039 1.582 5.468 1.7 6.498 1.965 1.03.264 7.321-1.473 16.606.733 9.285 2.206 10.474 2.66 10.474 2.66l-5.068-4.299Z"
    />
    <path
      fill="#fff"
      stroke="#363946"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      d="M46.29 122.916s-8.74-3.846-16.607-4.02c-7.867-.175-12.063 3.846-11.888 5.419.175 1.573 5.595 1.223 6.643 1.398 1.05.175 7.168-2.098 16.608-.699 9.44 1.398 10.664 1.748 10.664 1.748l-5.42-3.846Z"
    />
    <path
      fill="#fff"
      stroke="#363946"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      d="m158.026 119.681-12.138-3.287s-8.597-6.828-18.965-6.069c-10.368.759-19.724 4.805-22.759 7.08-3.034 2.276-6.827 4.552-7.586 5.058-.758.505-11.126-2.276-16.69 0-5.562 2.276-9.861 6.827-9.861 6.827s-23.517-7.08-29.333-8.092c-5.816-1.011-12.644-.505-17.449 3.035-4.805 3.54-3.793 5.816-1.264 6.322 2.529.505 3.034-2.023 16.942 1.77 13.908 3.793 30.85 13.655 37.678 17.448 6.828 3.793 18.207 9.104 25.793 6.828 7.586-2.276 28.322-10.115 33.127-10.115 4.804 0 20.23 1.012 20.23 1.012l2.275-27.817Z"
    />
    <path
      fill="#363946"
      stroke="#363946"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      d="m151.425 136.409-10.432 10.015 14.757 1.073-4.325-11.088Z"
    />
    <path
      stroke="#363946"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      d="M70.026 129.29s-2.348 3.087-1.358 7.088c.611 2.47 3.496 1.923 8.74.874 5.245-1.049.35-1.748 12.587-1.923 12.237-.175 25.349-.525 26.048-.525"
    />
    <path
      stroke="#363946"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      d="M69.938 137.867s.233-1.597 1.938-2.584c0 0 2.906-1.507 4.736-1.507 1.83 0 3.337 1.938 2.799 2.584M85.654 134.853V132.7M86.73 130.654s.323 1.184.108 3.014"
    />
    <path
      fill="#0038FF"
      stroke="#363946"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      d="M168.664 159.16h-16.309a1.796 1.796 0 0 1-1.795-1.796v-40.918c0-.991.804-1.795 1.795-1.795h16.309v44.509Z"
    />
    <path
      fill="#0038FF"
      stroke="#363946"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      d="M197.675 162.637H168.8a1.365 1.365 0 0 1-1.366-1.365v-47.54c0-.755.611-1.366 1.366-1.366h28.875v50.271Z"
    />
    <path
      stroke="#363946"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      d="M153.07 118.729h13.46M166.346 124.011h-13.684M152.182 133.614h9.363M163.226 133.614h3.12"
    />
  </svg>
)
export default NewHouseSvg
